import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const scrap = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("scrap"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("scrap/" + id));
    return data;
  },
  store: async (
    code,
    product_name,
    product_variant_id,
    qty,
    reason,
    description,
    status,
    qr_codes
  ) => {
    const { data } = await axios.post(h.baseUrl("scrap"), {
      code,
      product_name,
      product_variant_id,
      qty,
      reason,
      description,
      status,
      ip_address: await clientIp(),
      qr_codes,
    });
    return data;
  },
  update: async (
    id,
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    imageUrl
  ) => {
    const { data } = await axios.put(h.baseUrl("scrap/" + id), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      imageUrl,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("scrap/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default scrap;
